import React, { useState } from 'react';
import classNames from 'classnames';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { useHistory, useLocation } from 'react-router-dom';
import { useRouteConfiguration } from '../../context/routeConfigurationContext';
import { createSlug } from '../../util/urlHelpers';
import {
  IconFavourite,
  Modal
} from '../../components';
import { handleToggleFavourites } from '../../containers/ListingPage/ListingPage.shared';
import { manageDisableScrolling } from '../../ducks/ui.duck';
import { updateProfile } from '../../containers/ProfileSettingsPage/ProfileSettingsPage.duck';

import css from './AddToFavouritesButton.module.css';

const AddToFavouritesButtonComponent = props => {
  const {
    className,
    currentUser,
    onUpdateFavourites,
    listing,
    onDeleteFromFavorites,
    onOpenFafouriteModal
  } = props;

  const routeConfiguration = useRouteConfiguration();
  const history = useHistory();
  const location = useLocation();

  const id = listing.id.uuid;
  const { title = '' } = listing.attributes;
  const slug = createSlug(title);

  const commonParams = {
    params: { slug, id },
    history,
    routes: routeConfiguration,
  };

  const onToggleFavourites = handleToggleFavourites({
    ...commonParams,
    currentUser,
    onUpdateFavourites,
    location,
  });

  const isFavourite =
    currentUser?.attributes.profile.privateData.favourites?.includes(
      listing.id.uuid
    );

  const toggleFavourites = (e) => {
    e.preventDefault();
    e.stopPropagation();
    onToggleFavourites(isFavourite);
    onDeleteFromFavorites && onDeleteFromFavorites(id);
  };

  const classes = classNames(css.root, className);

  return (
    <div className={classes}>
      <div
        onClick={!!currentUser ? toggleFavourites : onOpenFafouriteModal}
        className={css.addToFavourites}
      >
        <IconFavourite isFavourite={isFavourite} />
      </div>
    </div>
  );
};

const mapStateToProps = state => {
  const { currentUser } = state.user;
  return { currentUser };
};

const mapDispatchToProps = dispatch => ({
  onManageDisableScrolling: (componentId, disableScrolling) =>
    dispatch(manageDisableScrolling(componentId, disableScrolling)),
  onUpdateFavourites: (payload) => dispatch(updateProfile(payload)),
});

// Note: it is important that the withRouter HOC is **outside** the
// connect HOC, otherwise React Router won't rerender any Route
// components since connect implements a shouldComponentUpdate
// lifecycle hook.
//
// See: https://github.com/ReactTraining/react-router/issues/4671
const AddToFavouritesButton = compose(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )
)(AddToFavouritesButtonComponent);

export default AddToFavouritesButton;
